export function controlPanel ($elements) {
	$elements.each((i, el) => {
		const $el = $(el);
		const $controlPanel = $('[data-control-panel]');
		const $elHeight = $el.outerHeight();

		$(window).on('load scroll', function () {
			let offset = $el.offset();
			if ($(window).scrollTop() > offset.top + $elHeight) {
				$controlPanel.addClass('is-visible');
			} else {
				$controlPanel.removeClass('is-visible');
			}
		});
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/control-panel.js